/* REWANA product-card gallery: one click / one synchronous photo change. */
(function () {
  'use strict';
  if (window.__rewanaCardGalleryInstalled) return;
  window.__rewanaCardGalleryInstalled = true;

  var gallerySelector = 'hdt-product-card-media[data-rewana-gallery]';
  var imageSelector = '.rewana-card-gallery__active-image[data-rewana-photo-index]';

  function getImages(gallery) {
    return gallery.querySelectorAll(imageSelector);
  }

  function getIndex(gallery) {
    var index = parseInt(gallery.getAttribute('data-rewana-index'), 10);
    return Number.isFinite(index) ? index : 0;
  }

  function showIndex(gallery, requested) {
    var images = getImages(gallery);
    var total = images.length + 1;
    if (total < 2) return;
    var next = ((requested % total) + total) % total;
    // The first photograph is the theme's existing original image.
    // All other photographs already have their own src, so no src rewrite,
    // asynchronous callback or second click is required to change the layer.
    for (var i = 0; i < images.length; i++) {
      images[i].classList.toggle('is-visible', i + 1 === next);
    }
    gallery.setAttribute('data-rewana-index', String(next));
  }

  function advance(gallery, direction) {
    if (!gallery) return;
    showIndex(gallery, getIndex(gallery) + direction);
  }

  // One delegated listener for static and AJAX-replaced product cards.
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('.rewana-card-gallery__arrow');
    if (!button) return;
    var gallery = button.closest(gallerySelector);
    if (!gallery) return;
    event.preventDefault();
    event.stopPropagation();
    advance(gallery, Number(button.getAttribute('data-rewana-direction')) || 1);
  }, true);

  // The pointer leaving the entire image area resets the card (not while
  // moving between an image and its arrows inside the same area).
  document.addEventListener('mouseout', function (event) {
    var media = event.target.closest && event.target.closest('.hdt-card-product__media');
    if (!media || (event.relatedTarget && media.contains(event.relatedTarget))) return;
    var gallery = media.querySelector(gallerySelector);
    if (gallery && getIndex(gallery) !== 0) showIndex(gallery, 0);
  }, true);

  var swipe = null;
  document.addEventListener('touchstart', function (event) {
    swipe = null;
    if (event.touches.length !== 1) return;
    if (event.target.closest && event.target.closest('.rewana-card-gallery__arrow')) return;
    var gallery = event.target.closest && event.target.closest(gallerySelector);
    if (!gallery) return;
    swipe = { gallery: gallery, x: event.touches[0].clientX, y: event.touches[0].clientY };
  }, { capture: true, passive: true });

  document.addEventListener('touchend', function (event) {
    if (!swipe || !event.changedTouches.length) return;
    var gesture = swipe;
    swipe = null;
    var dx = event.changedTouches[0].clientX - gesture.x;
    var dy = event.changedTouches[0].clientY - gesture.y;
    if (Math.abs(dx) < 45 || Math.abs(dx) <= Math.abs(dy) * 1.3) return;
    event.preventDefault();
    event.stopPropagation();
    advance(gesture.gallery, dx < 0 ? 1 : -1);
  }, { capture: true, passive: false });

  document.addEventListener('touchcancel', function () { swipe = null; }, true);
}());